import { Button, Paper, styled } from "@mui/material";
import { Form } from "formik";

export const StyledErroresConectividadCardDetail = {
  Paper: styled(Paper)(({ theme }) => ({
    marginBottom: 10,
    padding: 10,
    display: "flex",
  })),

  ActionsContainer: styled("div")({
    display: "flex",
    alignItems: "center",
  }),

  Icon: styled("div")({
    margin: 5,
    cursor: "pointer",
  }),
};
export const StyledSearch = {
  Input: styled("div")(({ theme }) => ({
    marginRight: 20,
    width: 250,
  })),

  Checkbox: styled("div")(({ theme }) => ({
    marginTop: 20,
  })),

  ButtonContainer: styled("div")(({ theme }) => ({
    width: 250,
    marginTop: "15%",
  })),

  StyledButton: styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
  })),
};

export const StyledSearchContainer = {
  Container: styled("div")({
    marginBottom: "24px",
  }),
  Title: styled("div")({
    color: "#484848",
    marginBottom: "8px",
    fontFamily: "Roboto, sans-serif",
    fontSize: "large",
    fontWeight: 500,
  }),
  Form: styled(Form)({
    width: "100%",
    display: "flex",
  }),
};

export const StyledNovedadesSearchForm = {
  StyledPaper: styled(Paper)({
    display: "flex",
    flexWrap: "wrap",
    padding: 20,
    marginBottom: 20,
  }),
  StyledInput: styled("div")({
    display: "inline-flex",
    marginRight: 20,
    width: 250,
  }),
  ButtonContainer: styled("div")({
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "auto",
  }),
  StyledButton: styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
  })),
};
